export default __webpack_public_path__ + "static/media/header5.4d93867e.jpg";